import React, { memo } from 'react';

import { FilterOutlined } from '@ant-design/icons';
import { Input } from 'antd';

export type InputProductSearchType = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value: string;
  handleSearchEnter: (v: string) => void;
};

export const InputProductSearch = memo((props: InputProductSearchType) => {
  return (
    <Input
      id='search-product-input'
      value={props.value}
      suffix={<FilterOutlined style={{ fontSize: 24 }} />}
      onChange={props.onChange as any}
      style={{ minWidth: '330px', width: '100%', height: '40px', marginBottom: '16px' }}
      onKeyPress={props.onKeyPress as any}
      placeholder='Pesquise pelo título ou ID do produto'
    />
  );
});
